module.exports = __webpack_public_path__ + "img/floors.f1737b3b.png";